export enum USER_ROLES{
    'ADMIN' = 'Admin',
    'TEAMS' = 'TEAMS',
    'LEA' = 'LEA',
    'LEA2' = 'LEA2',
    'IHE' = 'IHE',
    'LEA3RDPARTY' = 'LEA3RDPARTY',
    'APPLICANT' = 'APPLICANT',
    'LEA_PA' = 'LEA-PA',
    'LEA_VHD' = 'LEA-VHD',
}

export const ROLE_DISPLAY_NAMES: Record<string, string> = {
    'LEA': 'School System Responsibility',
    'IHE': 'College/University Responsibility',
    'TEAMS': 'TEAMS Responsibility',
    'LEA3rdParty': 'School System Responsibility',
    'Applicant': 'Applicant Responsibility',
    'LEA-PA': 'School System Responsibility',
    'LEA-VHD': 'School System Responsibility',
};